export default {
  options: 'Import options',
  formatSelection: 'To import the file successfully, select the format of the invoices to be imported.',
  format: 'Format',
  preserveId: 'Import keeping the series and number',
  signed: 'Invoice signed',
  file: 'File',
  formatTypes: {
    label: 'Formats',
    text: '{0}: Excel, XML.'
  },
  maxSize: {
    label: 'Maximum size',
    text: '{0}: 10 Mb'
  },
  accept: 'Accept',
  cancel: 'Cancel',
  errors: {
    400: {
      1000: 'The format field is mandatory'
    }
  },
  correct: 'Correct',
  rejected: 'Rejected',
  notTreated: 'No treated'
}
